import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import UniversalModalOverride from "../../../../../components/UniversalModalOverride";
import {Tab, Tabs} from "@material-ui/core";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Davidsons Products',
		url: '/davidsons_products',
		icon: 'shopping-bag',
	},
];

export default class Davidsons_Products extends Framework.Components.View {
	constructor(props) {
		super(props, 'products');
	}

	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Tabs value={this.state.tab} onChange={this.handleTabChange} component="div">
						<Tab label="Products" value="products"/>
						<Tab label="History" value="history"/>
					</Tabs>

				</Framework.Components.PageBar>

				<div style={{display: this.state.tab === 'products' ? 'block' : 'none'}}>
					<Collections.DavidsonsProducts
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
					/>
				</div>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name={"Davidsons Transfer"}
					object={Objects.DavidsonsTransfer}
					history={this.props.history}
					toggle={this.state['davidsonsTransfer']}
					reportClose={this.reportClose('davidsonsTransfer')}
					afterSave={this.handleAfterSave}
					// objectProps={{scannedCode: this.state['davidsonsTransfer'] ? this.props.scannedCode : null}}
				/>


				{this.state.tab === 'history' && <Collections.DavidsonsCompleted
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}

			</div>
		);
	}
}
